import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import { createStateSyncMiddleware } from "redux-state-sync";
import reducer from "./reducers";
import rootSaga from "./sagas";
import {
  SET_THEME_MODE,
  SET_IS_LOGOUT,
  SET_COMPANY_LOGO,
  SET_PORTAL_FLOWS
} from "./constants/portal";
import { SET_COMPONENTS } from "./constants/flowDesigner";
import { useSelector, shallowEqual } from "react-redux";

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer,
  middleware: [
    sagaMiddleware,
    createStateSyncMiddleware({
      whitelist: [SET_THEME_MODE, SET_IS_LOGOUT, SET_COMPANY_LOGO, SET_PORTAL_FLOWS, SET_COMPONENTS]
    })
  ]
});

sagaMiddleware.run(rootSaga);

export function useShallowEqualSelector(selector) {
  return useSelector(selector, shallowEqual);
}

export default store;
